<template>

  <div>

    <v-overlay :value="overlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="invalidCredentialsSnackbar" color="error">

      You have entered invalid credentials.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="invalidCredentialsSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-container>

      <v-row>

        <v-col>

          <v-card text="" flat class="pa-4 rwb-card mb-4">

            <p><strong>Warning:</strong> The browser back button does not work within the system.  Any unsaved information will be lost if used.</p>

          </v-card>

        </v-col>

      </v-row>

      <v-row>

        <v-col cols="12">

          <h2 class="pt-3">Sign in</h2>

          <p class="pt-3">Sign in with your email address and password</p>

        </v-col>

      </v-row>

      <v-row>

        <v-col cols="12" sm="6" md="4" class="py-0">

          <v-text-field label="Email" v-model="loginInfo.email" type="text" :error-messages="emailErrors" maxlength="100" outlined @keyup.enter="login"></v-text-field>

        </v-col>

      </v-row>

      <v-row>

        <v-col cols="12" sm="6" md="4" class="py-0">

          <v-text-field label="Password" v-model="loginInfo.password" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" :error-messages="passwordErrors" maxlength="30" outlined @keyup.enter="login"></v-text-field>

          <div class="text-right"> <a class="ml-2" @click="forgotPassword">Forgot password?</a></div>

        </v-col>

      </v-row>

      <v-row>

        <v-col cols="12">

          <v-btn size="large" class="btn rounded-0" @click="login">Sign in</v-btn>

        </v-col>

      </v-row>

      <v-row>

        <v-col cols="12">

          <p>Don’t have an account? <a @click="navigateToRegister"><strong>Create an account</strong></a></p>

        </v-col>

      </v-row>

    </v-container>

  </div>

</template>

<script>

import Vue from 'vue'

import { required } from "vuelidate/lib/validators";

import axios from "axios";

function validateEmail(value) {

  return value == null || value == "" || value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null;

}

export default Vue.extend({

  name: 'Login',

  data: () =>
  {
    return {

      overlay: false,

      loginInfo: {

        email: '',

        password: ''

      },

      errorSnackbar: false,

      invalidCredentialsSnackbar: false,

      showPassword: false

    };
  },

  async created() {

    try {

      var getCookie = (cName) => {

        const name = cName + "=";

        const cDecoded = decodeURIComponent(document.cookie);

        const cArr = cDecoded.split("; ");

        let value = '';

        cArr.forEach(val => {

          if(val.indexOf(name) === 0){

            value = val.substring(name.length);

          }

        })

        return value;
      }

      if (getCookie('cookiesconsent_showPopup') == '') {

        var setCookie = (cName, cValue, expDays) => {

          let date = new Date();

          date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));

          const expires = "expires=" + date.toUTCString();

          document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";

        }

        setCookie('cookiesconsent_showPopup', false, 90);

      }

      this.$store.dispatch('updateShowCookieBanner', false);

      // get the user profile

      let obj = await axios.get('accounts/GetUserProfile');

      if (obj.data.role == 'User') {

        this.$router.push('/Dashboard');

      }
      else if (obj.data.role == 'Admin') {

        this.$router.push('/Admin/Dashboard');

      }

      this.$store.dispatch('updateUserProfile', obj.data);

    }
    catch
    {
      // the user is not signed in (do nothing)
    }

  },

  methods:
      {
        navigateToRegister() {

          this.$router.push('/Register');

        },

        async login() {

          this.$v.loginInfo.$touch();

          if (!this.$v.loginInfo.$invalid) {

            this.clearSnackbars();

            this.overlay = true;

            setTimeout(async () => {

              let obj = await axios.post('accounts/authenticate', this.loginInfo);

              this.overlay = false

              if (obj.data == '%%INVALID_CREDENTIALS%%')
              {
                this.invalidCredentialsSnackbar = true;
              }
              else
              {
                if (obj.data.role == 'User') {

                  this.$router.push('/Dashboard');

                }
                else if (obj.data.role == 'Admin') {

                  this.$router.push('/Admin/Dashboard');

                }
              }

            }, 200);

          } else {

            this.errorSnackbar = true;

          }
        },

        clearSnackbars() {

          this.errorSnackbar = false;

          this.invalidCredentialsSnackbar = false;

        },

        forgotPassword()
        {

          this.$router.push('/ForgotPassword');

        },

        register()
        {

          this.$router.push('/Register');

        }

      },

  validations:
      {
        loginInfo:
            {
              email: {

                required,

                validateEmail

              },

              password: {

                required

              }
            }
      },

  computed:
      {
        emailErrors()
        {
          if (this.$v.loginInfo.email && !this.$v.loginInfo.email.$dirty) return [];

          if (this.$v.loginInfo.email && !this.$v.loginInfo.email.required) return ['Email is required.'];

          if (this.$v.loginInfo.email && !this.$v.loginInfo.email.validateEmail) return ['Email is invalid.'];

          return null;
        },

        passwordErrors()
        {
          if (this.$v.loginInfo.password && !this.$v.loginInfo.password.$dirty) return [];

          if (this.$v.loginInfo.password && !this.$v.loginInfo.password.required) return ['Password is required.'];

          return null;
        }
      }

})

</script>
